<div>
  <div class="mt-6 mb-4">
    <div class="flex justify-between w-full py-2 gap-2">
      <div class="flex items-center gap-2">
        <button class="btn-icon" (click)="openConfigVoo()" [matTooltip]="'Configuração de Atualização de Voos'">
          <mat-icon>settings</mat-icon>
        </button>
        <mat-form-field class="input-tg" appearance="outline">
          <mat-label>Ordenação</mat-label>
          <mat-select [(value)]="orderBySelected" (selectionChange)="sortChange($event)">
            @for (sort of sorts; track sort){
              <mat-option [value]="sort.id">
                {{ sort.description }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="gap-2 flex items-center">
        @if (selectedPassengers.length > 0) {
          <button mat-flat-button class="btn-tg-cancel" [disabled]="deletingBatch" (click)="deleteBatch()">
            @if (deletingBatch) {
              <mat-spinner diameter="18" class="loading-spinner"></mat-spinner>
            } @else {
              Excluir ({{ selectedPassengers.length }})
            }
          </button>
        }
        @if (itemsList.length > 0) {
          <button mat-flat-button class="btn-tg-cancel" [disabled]="deletingBatch" (click)="deleteAllPassengers()">
            @if (deletingBatch) {
              <mat-spinner diameter="18" class="loading-spinner"></mat-spinner>
            } @else {
              Excluir Todos
            }
          </button>
        }
        <button mat-button class="btn-tg" (click)="getImportModel()">
          Baixar Modelo
        </button>
        <button mat-button class="btn-tg" (click)="importPassenger()">
          Importar
        </button>
        <button mat-button class="btn-tg" (click)="openImportHistory()">
          Histórico
        </button>
        <button mat-button class="btn-tg" (click)="addPassenger()">
          Adicionar
        </button>
      </div>
    </div>
    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title> Pesquisa </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <form-passenger-logistics-search [search]="inputSearch" (responseSearch)="search($event)" />
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
  <div class="mt-4">
    <div>
      @if (!loading) {
        <div>
          <table-list-logistics-passenger
            [dataSource]="itemsList"
            [columns]="columns"
            [passengers]="true"
            [selectable]="true"
            (selectionChange)="onSelectionChange($event)"
            (selectItem)="editItem($event)"
            (managerItem)="editItem($event)"
            (deleteItem)="deletePassenger($event)"
          />
          @if (itemsList.length > 0) {
            <mat-paginator
              [length]="numberRows"
              [pageSize]="rows"
              [pageIndex]="page - 1"
              [pageSizeOptions]="[5, 10, 20, 30]"
              (page)="onPageEvent($event)"
            >
            </mat-paginator>
          }
        </div>
      } @else {
        <div>
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      }
    </div>
  </div>
</div>
